export default {
    cct(state, data) {
      state.cct = data;
    },
    administrativeAreas(state, data) {
        state.administrative_areas = data;
    },
  };
  